<form
  [ngStyle]="{'justify-content': alignment}"
        (submit)="onSubmit($event)"
        class="quantity-picker"
        [ngClass]="mode">
        
  <button
          (click)="makeActive($event)"
          [ngStyle]="{'right': alignment === 'flex-start' ? 'auto' : 0}"
          class="btn btn-default quantity-picker_add"
          [ngClass]="{'-has-text': addButtonText}"
          [@addButtonState]="state"
          type="button">
    {{ addButtonText }}
    <i class="fa fa-plus"></i>
  </button>

  <button
          [@pickerState]="state"
          [disabled]="!(zeroAllowed || (!zeroAllowed && (currentQuantity !== minQuantity)))"
          type="button"
          class="btn btn-default quantity-picker_minus"
          (click)="change($event, -1)">
    <i class="fa fa-minus"></i>
  </button>
  <input
          [@pickerState]="state"
          class="quantity-picker_field"
          #input
          (click)="prevent($event)"
          type="number"
          min="0"
          [formControl]="control"/>
  <button
          [@pickerState]="state"
          type="button"
          class="btn btn-default quantity-picker_plus"
          (click)="change($event, 1)">
    <i class="fa fa-plus"></i>
  </button>
</form>

